/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import gql from 'graphql-tag';

import { Link, Typography, Typography2 } from '@coursera/cds-core';

import type { RelatedCollectionsFragment as RelatedCollectionsFragmentType } from 'bundles/collections/components/__generated__/RelatedCollectionsFragment';
import withFragments from 'bundles/graphql/components/withFragments';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

type Props = {
  relatedCollections: RelatedCollectionsFragmentType;
};

const styles = {
  relatedCollectionCard: css`
    background-color: #e7fdff;
    height: 200px;
    width: 372px;
    display: inline-block;
  `,
  relatedText: css`
    text-transform: uppercase;
  `,
};

class RelatedCollections extends React.Component<Props> {
  render() {
    const { relatedCollections } = this.props;
    return (
      <div>
        {relatedCollections.elements.map((collection) => {
          return collection ? (
            <Link
              key={collection.slug}
              variant="quiet"
              enableVisitedState={false}
              component={TrackedA}
              css={styles.relatedCollectionCard}
              className="p-x-2 p-y-3 m-r-1 m-b-1"
              target="_blank"
              rel="noopener noreferrer"
              trackingName="related_collection"
              href={`/collections/${collection.slug}`}
              data={{ relatedCollectionSlug: collection.slug }}
            >
              <Typography2 component="p" css={styles.relatedText} variant="subtitleMedium">
                Related
              </Typography2>
              <Typography component="p" variant="h1semibold">
                {collection.title}
              </Typography>
            </Link>
          ) : null;
        })}
      </div>
    );
  }
}

const RelatedCollectionsFragment = gql`
  fragment RelatedCollectionsFragment on CatalogCollectionPagesV1Connection {
    elements {
      slug
      title
      id
    }
  }
`;

export default withFragments({
  RelatedCollectionsFragment,
})(RelatedCollections);
